export const getAvailableTerminalDevicesState = (state) => state.availableTerminalDevices;
export const getTerminalDevicesState = (state) => state.terminalDevices;
export const getTerminalDeviceState = (state) => state.terminalDevice;
